export default __webpack_public_path__ + "static/media/rephrase-cursor-2.74eb2b56.png";